export default "__VITE_ASSET__CCcv$YYC__"